<template>
    <div class="block text-blue-500">
        <div
            v-if="text"
            class="relative pb-2 text-sm"
            :class="[{ 'mr-8': tooltipText }, classText]"
        >
            <label class="inline-block mr-2">{{ text }}</label>
        </div>

        <p v-if="instructions" class="mb-4 tiny text-grey-500">{{ instructions }}</p>

        <div :class="{ 'border border-red-500': invalid && errorOutline }">
            <slot />
        </div>

        <BaseErrors v-if="validation" :field-validation="validation" />
    </div>
</template>

<script>
import BaseErrors from '@/../vue/_base/form/Errors.vue';

export default {
    components: {
        BaseErrors
    },

    props: {
        text: {
            type: String,
            default: null
        },
        instructions: {
            type: String,
            default: null
        },
        tooltipText: {
            type: String,
            default: null
        },
        validation: {
            type: Object,
            default: null
        },
        errorOutline: {
            type: Boolean,
            default: true
        },
        classText: {
            type: String,
            default: ''
        }
    },

    computed: {
        invalid() {
            return this.validation && this.validation.$error;
        }
    }
};
</script>
